import { PipelinesPaths } from 'app/configs/routesConfig/pipelines';
import { dealApi } from 'app/services/api';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { getDefaultErrorMessage } from 'utils/axios';
import { logger } from 'utils/logger';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { showErrorMessageAction } from 'store/global/actions';

export const DEAL_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/deal`,
  {
    GET_DEAL_DATA: 'GET_DEAL_DATA',
    SET_DEAL_DATA: 'SET_DEAL_DATA',
    RESET_DEAL_DATA: 'RESET_DEAL_DATA',
  },
);

// Main action, should be used for further development if needed
export const getDealDataByApplicationIdAction =
  ({ applicationId, history }) =>
  async dispatch => {
    try {
      const { data } = await dealApi.getDataByApplicationId({ applicationId });

      return dispatch({
        type: DEAL_ACTION_TYPE.GET_DEAL_DATA,
        payload: data,
      });
    } catch (err) {
      logger.error(err);
      history.push(PipelinesPaths.loanPipelines.path);

      dispatch(
        showErrorMessageAction({
          message: getDefaultErrorMessage(err),
          err,
        }),
      );
    }
  };

// Should not be used except LoanApplicationPage case. Use getDealDataByApplicationIdAction with applicationId instead
export const getDealDataByLoanIdAction = catchAsyncActionError(({ loanId }) => async dispatch => {
  const { data } = await dealApi.getDataByLoanId({ loanId });

  return dispatch({
    type: DEAL_ACTION_TYPE.GET_DEAL_DATA,
    payload: data,
  });
});

export const setDealDataAction = data => dispatch => {
  return dispatch({
    type: DEAL_ACTION_TYPE.GET_DEAL_DATA,
    payload: data,
  });
};

export const resetDealDataAction = data => ({
  type: DEAL_ACTION_TYPE.RESET_DEAL_DATA,
  payload: data,
});
